import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

export default function CTABand() {
  return (
    <section className="bg-ink-0 text-parchment relative overflow-hidden" data-testid="cta-band">
      <div className="absolute inset-0 glow-rust opacity-80 pointer-events-none" aria-hidden="true" />
      <div className="absolute inset-0 grid-faint opacity-50 pointer-events-none" aria-hidden="true" />
      <div className="container-edge py-20 lg:py-28 relative z-10">
        <Reveal className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-8">
            <div className="eyebrow mb-5">
              Begin the conversation
            </div>
            <h2 className="font-serif font-light text-3xl md:text-5xl lg:text-6xl tracking-tight max-w-3xl text-parchment-bright">
              Tell us where you are in the lifecycle. We&rsquo;ll show you what voice can become.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:text-right">
            <Link to="/contact" className="btn-accent" data-testid="cta-band-link">
              Request a Briefing
            </Link>
            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-muted-on-dark mt-4">
              45-min strategic walkthrough · Confidential
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
